import React from 'react';
import Hero from "../../common/Hero/Hero";
import './SpidLogin.scss';
import SpidLogo from "../../OauthAuthentication/Assets/spid-logo-b-lb.svg";
import ArrowLink from "../../common/ArrowLink/ArrowLink";
import spidButton from "../../OauthAuthentication/Assets/spid-button.svg";
import spidAgidLogo from "../../OauthAuthentication/Assets/spid-agid-logo-lb.svg";
import { signInWithRedirect } from 'aws-amplify/auth';
import Configuration from "../../../config";

const SpidLogin = () => {
  return (
    <div className="container">
      <div className={"SpidLogin w-100"} data-testid={"SpidLogin"}>
        <Hero  backToText={"Accedi alla tua area personale"} title={"Accedi con SPID"} description={"Usa le tue credenziali SPID per accedere all'area personale"}/>
        <div style={{display: "flex", flexDirection: 'row', flexWrap:'wrap'}}>
          <div className="col-md-5">
           <div className="order-1">
             <img src={SpidLogo} className="spid-logo-b-lb" alt="spid-logo"/>
             <h1 className="text-style-1">Che cos’è lo SPID?</h1>
             <p> È un sistema di autenticazione che consente di avere un’identità digitale unica con la quale è
               possibile
               accedere ai servizi online di pubbliche amministrazioni e privati che sono parte del sistema SPID.</p>
             <h1 className="text-style-1">Sei già in possesso di un’utenza SPID?</h1>
             <p> Accedi con le credenziali fornite dal tuo gestore.</p>
           </div>

          </div>
          <div className="col-md-6 order-2">
            <img src={spidButton}
                 alt="spid-button"
                 onClick={() => signInWithRedirect({
  provider: {
    custom: Configuration.get('REACT_APP_OAUTH_IDENTITY_PROVIDER')
  }
})}
                 className="spid-button-link-link" />
            <span className="Maggiori-informazion">
 <u> Maggiori informazioni su SPID</u>
</span>
          </div>
        </div>

      </div>
      <div className="Rectangle">

        <ArrowLink to={"/register"}>
                 <span className="Non-sei-in-possesso">
                   <h1 className="text-style-1">Non sei in possesso di SPID?</h1>Puoi attivarlo, gratuitamente o a pagamento, sul sito di uno dei gestori di identità abilitati.
                 </span>

        </ArrowLink>
      </div>
      <div className="col-sm-12 col-md-5 offset-md-4 ">
        <img src={spidAgidLogo}
             alt="spid-aid"
             className="spid-agid-logo-lb" />

      </div>
    </div>
  )
}
export default SpidLogin;
